/**
 * Generated by orval v6.29.1 🍺
 * Do not edit manually.
 * MS API Documentation
 * OpenAPI spec version: 1.0.0
 */
import {useQuery, useSuspenseQuery} from '@tanstack/react-query';
import type {
    QueryFunction,
    QueryKey,
    UseQueryOptions,
    UseQueryResult,
    UseSuspenseQueryOptions,
    UseSuspenseQueryResult,
} from '@tanstack/react-query';
import type {
    GetAppCountryCountries200Item,
    GetAppCountryRegionsbycountry200Item,
} from '../mSAPIDocumentation.schemas';
import {fetcherMs} from '../../axios-instance';

/**
 * @summary Get list of countries
 */
export const getAppCountryCountries = (signal?: AbortSignal) => {
    return fetcherMs<GetAppCountryCountries200Item[]>({
        url: `/directory/country`,
        method: 'GET',
        signal,
    });
};

export const getGetAppCountryCountriesQueryKey = () => {
    return [`/directory/country`] as const;
};

export const getGetAppCountryCountriesQueryOptions = <
    TData = Awaited<ReturnType<typeof getAppCountryCountries>>,
    TError = unknown,
>(options?: {
    query?: Partial<
        UseQueryOptions<Awaited<ReturnType<typeof getAppCountryCountries>>, TError, TData>
    >;
}) => {
    const {query: queryOptions} = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetAppCountryCountriesQueryKey();

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAppCountryCountries>>> = ({signal}) =>
        getAppCountryCountries(signal);

    return {queryKey, queryFn, ...queryOptions} as UseQueryOptions<
        Awaited<ReturnType<typeof getAppCountryCountries>>,
        TError,
        TData
    > & {queryKey: QueryKey};
};

export type GetAppCountryCountriesQueryResult = NonNullable<
    Awaited<ReturnType<typeof getAppCountryCountries>>
>;
export type GetAppCountryCountriesQueryError = unknown;

/**
 * @summary Get list of countries
 */
export const useGetAppCountryCountries = <
    TData = Awaited<ReturnType<typeof getAppCountryCountries>>,
    TError = unknown,
>(options?: {
    query?: Partial<
        UseQueryOptions<Awaited<ReturnType<typeof getAppCountryCountries>>, TError, TData>
    >;
}): UseQueryResult<TData, TError> & {queryKey: QueryKey} => {
    const queryOptions = getGetAppCountryCountriesQueryOptions(options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {queryKey: QueryKey};

    query.queryKey = queryOptions.queryKey;

    return query;
};

export const getGetAppCountryCountriesSuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof getAppCountryCountries>>,
    TError = unknown,
>(options?: {
    query?: Partial<
        UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAppCountryCountries>>, TError, TData>
    >;
}) => {
    const {query: queryOptions} = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetAppCountryCountriesQueryKey();

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAppCountryCountries>>> = ({signal}) =>
        getAppCountryCountries(signal);

    return {queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getAppCountryCountries>>,
        TError,
        TData
    > & {queryKey: QueryKey};
};

export type GetAppCountryCountriesSuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof getAppCountryCountries>>
>;
export type GetAppCountryCountriesSuspenseQueryError = unknown;

/**
 * @summary Get list of countries
 */
export const useGetAppCountryCountriesSuspense = <
    TData = Awaited<ReturnType<typeof getAppCountryCountries>>,
    TError = unknown,
>(options?: {
    query?: Partial<
        UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAppCountryCountries>>, TError, TData>
    >;
}): UseSuspenseQueryResult<TData, TError> & {queryKey: QueryKey} => {
    const queryOptions = getGetAppCountryCountriesSuspenseQueryOptions(options);

    const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
};

/**
 * @summary Get list of regions by country
 */
export const getAppCountryRegionsbycountry = (id: string, signal?: AbortSignal) => {
    return fetcherMs<GetAppCountryRegionsbycountry200Item[]>({
        url: `/directory/country/${id}/region`,
        method: 'GET',
        signal,
    });
};

export const getGetAppCountryRegionsbycountryQueryKey = (id: string) => {
    return [`/directory/country/${id}/region`] as const;
};

export const getGetAppCountryRegionsbycountryQueryOptions = <
    TData = Awaited<ReturnType<typeof getAppCountryRegionsbycountry>>,
    TError = unknown,
>(
    id: string,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getAppCountryRegionsbycountry>>,
                TError,
                TData
            >
        >;
    },
) => {
    const {query: queryOptions} = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetAppCountryRegionsbycountryQueryKey(id);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAppCountryRegionsbycountry>>> = ({
        signal,
    }) => getAppCountryRegionsbycountry(id, signal);

    return {queryKey, queryFn, enabled: !!id, ...queryOptions} as UseQueryOptions<
        Awaited<ReturnType<typeof getAppCountryRegionsbycountry>>,
        TError,
        TData
    > & {queryKey: QueryKey};
};

export type GetAppCountryRegionsbycountryQueryResult = NonNullable<
    Awaited<ReturnType<typeof getAppCountryRegionsbycountry>>
>;
export type GetAppCountryRegionsbycountryQueryError = unknown;

/**
 * @summary Get list of regions by country
 */
export const useGetAppCountryRegionsbycountry = <
    TData = Awaited<ReturnType<typeof getAppCountryRegionsbycountry>>,
    TError = unknown,
>(
    id: string,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getAppCountryRegionsbycountry>>,
                TError,
                TData
            >
        >;
    },
): UseQueryResult<TData, TError> & {queryKey: QueryKey} => {
    const queryOptions = getGetAppCountryRegionsbycountryQueryOptions(id, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {queryKey: QueryKey};

    query.queryKey = queryOptions.queryKey;

    return query;
};

export const getGetAppCountryRegionsbycountrySuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof getAppCountryRegionsbycountry>>,
    TError = unknown,
>(
    id: string,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getAppCountryRegionsbycountry>>,
                TError,
                TData
            >
        >;
    },
) => {
    const {query: queryOptions} = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetAppCountryRegionsbycountryQueryKey(id);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAppCountryRegionsbycountry>>> = ({
        signal,
    }) => getAppCountryRegionsbycountry(id, signal);

    return {queryKey, queryFn, enabled: !!id, ...queryOptions} as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getAppCountryRegionsbycountry>>,
        TError,
        TData
    > & {queryKey: QueryKey};
};

export type GetAppCountryRegionsbycountrySuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof getAppCountryRegionsbycountry>>
>;
export type GetAppCountryRegionsbycountrySuspenseQueryError = unknown;

/**
 * @summary Get list of regions by country
 */
export const useGetAppCountryRegionsbycountrySuspense = <
    TData = Awaited<ReturnType<typeof getAppCountryRegionsbycountry>>,
    TError = unknown,
>(
    id: string,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getAppCountryRegionsbycountry>>,
                TError,
                TData
            >
        >;
    },
): UseSuspenseQueryResult<TData, TError> & {queryKey: QueryKey} => {
    const queryOptions = getGetAppCountryRegionsbycountrySuspenseQueryOptions(id, options);

    const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
};
